export default function getCompositionsStore(context, customerId) {
  customerId = customerId || context.stores.currentLocation.get().customerId;
  if (customerId && context.stores.customers.has({ id: customerId })) {
    return context.stores.customers.storesFor(customerId).compositions;
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/customer/lib/get_compositions_store.js